import React, { useState } from 'react';
import ReactMarkdown from 'markdown-to-jsx';
import { OptimizelyFeature } from '@ynap/optimizely-utils';
import BEMHelper from '@ynap/bem-helper';
import Skeleton from '@ynap/skeleton';
import { formatPrice } from '@ynap/intl-formatters';

const bem = new BEMHelper('ProductDetails');

const handleClick = (optimizely, trackParameter) => {
    optimizely?.track?.(trackParameter);
};

export const KlarnaMessage = (props) => {
    const { messages, country, config: { head: { pdp: { klarnaPromoLink = '' } = {} } = {} } = {}, showKlarnaMessage, buyable, price, locale } = props;

    return (
        <OptimizelyFeature
            feature={[
                'web00001_klarnafinancingmessage_pdp_us',
                'web00067_klarnafinancingmessage_pdp_us',
                'web00010_klarnapaylater_pdp_nap_uk',
                'web00011_klarnapaylater_pdp_nap_de_at',
                'web00064_klarnapayin3_nap_pdp_it_fr_sp',
                'web00305_klarnapaylater2_pdp_nap',
            ]}
            country={props.country}
        >
            {(props) => {
                // if optimizely exists it will load the skeleton and disable it on ready; else renders right away
                const [isLoading, setIsLoading] = useState(!!props?.optimizely);
                props?.optimizely?.onReady?.({ timeout: 2000 })?.then?.(() => {
                    setIsLoading(false);
                });

                const experiment = props?.feature && props?.feature?.split?.('_')[0];
                const variation = props?.variationKey;
                const splittedPrice = price?.finalPrice && price?.currency && formatPrice(price?.finalPrice / 3, price?.currency.label, locale);
                const klarnaMessage =
                    props?.variables?.enabled && buyable?.canAddToBag && experiment && variation && splittedPrice
                        ? messages.klarnaMessage[experiment]({ variation, splittedPrice, klarnaPromoLink })
                        : showKlarnaMessage
                          ? messages.klarnaMessage.shopNowPayWith({ country, klarnaPromoLink })
                          : undefined;

                return !isLoading ? (
                    <ReactMarkdown
                        options={{
                            forceBlock: true,
                            overrides: {
                                p: (node) => <p className={bem('shopWithBrand')}>{node.children}</p>,
                                em: () => (
                                    <em
                                        onClick={() => klarnaMessage && handleClick(props?.optimizely, 'klarna_logo_clicks')}
                                        className={bem('shopWithBrandLogo')}
                                    />
                                ),
                                a: (node) => (
                                    <a
                                        onClick={() => klarnaMessage && handleClick(props?.optimizely, 'klarna_link_clicks')}
                                        className={bem('shopWithBrandLink')}
                                        href={`/${locale}${node.href}`}
                                    >
                                        {node.children}
                                    </a>
                                ),
                            },
                        }}
                    >
                        {klarnaMessage || ''}
                    </ReactMarkdown>
                ) : (
                    <Skeleton containerClassName={bem('klarnaMessageSkeletonContainer')} className={bem('klarnaMessageSkeleton')} count={2} />
                );
            }}
        </OptimizelyFeature>
    );
};
